/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: dpdRoEHB1RdkpQGeaRP58K

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsenrDmrqRhdzt } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: EnrDMRQRhdzt/globalVariant
import { SegmentValue, useSegment } from "./PlasmicGlobalVariant__Segment"; // plasmic-import: sjmadt8OGfs4/globalVariant
import { Segment2Value, useSegment2 } from "./PlasmicGlobalVariant__Segment2"; // plasmic-import: NRRLAR9UoINl/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsenrDmrqRhdzt,
  segment: useSegment,
  segment2: useSegment2
});
